import { setContactSupportVisible } from '../contact_support_slice'

export const showContactSupportModal = (tier) => (dispatch) => {
  if (tier) {
    dispatch(setContactSupportVisible({ tier }))
  }
}
